// @flow
import type { Event } from 'effector'
import { decamelizeString } from 'utils/camelize'
import type { CreateConfig, Widget } from '../types'
import { domain } from './domain'

export const setMounted: Event<boolean> = domain.createEvent('set mounted flag')

export const setWidgetsTransformed: Event<$PropertyType<CreateConfig, 'widgets'>> = domain.createEvent(
  'set widgets transformed'
)

export const setWidgets: Event<$PropertyType<CreateConfig, 'widgets'>> = setWidgetsTransformed.prepend((data) => {
  return data.map((item) => ({ ...item, name: decamelizeString(item.name).toUpperCase() }))
})

export const updateWidget: Event<{|
  name: $PropertyType<Widget<{ ... }>, 'name'>,
  props: Widget<{ ... }>,
|}> = domain.createEvent('update widget')
